/**
 * Flutter WebView bridge (react-native-webview-style API).
 * In browser: logs JSON payload; in Flutter: posts to native.
 */

export function sendToFlutter(eventName: string): void {
  const message = JSON.stringify({
    event: eventName,
    payload: {},
    timestamp: Date.now(),
  });

  const bridge = window.ReactNativeWebView;
  if (bridge && typeof bridge.postMessage === "function") {
    bridge.postMessage(message);
    return;
  }

  console.log(`[FlutterBridge] ${eventName}`, message);
}
